import { Component } from '@angular/core';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { AbModule } from '@df/module-ab/ab.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { BasketViewCouponFormComponent } from '../../basket/view-coupon-form/basket-view-coupon-form.component';
import { AddressShortComponent } from '../../ui/display/address-short/address-short.component';
import { Section1Component } from '../../ui/display/section1/section1.component';
import { CheckoutAddresssComponent } from '../address/checkout-address.component';
import { CheckoutExpandableComponent } from '../expandable/checkout-expandable.component';
import { CheckoutFormComponent } from '../form/checkout-form.component';
import { CheckoutPaymentMethodsComponent } from '../payment-methods/checkout-payment-methods.component';
import { CheckoutSubmitComponent } from '../submit/checkout-submit.component';
@Component({
    selector: 'checkout-payment',
    templateUrl: './checkout-payment.html',
    standalone: true,
    imports: [
        CheckoutSubmitComponent,
        CheckoutAddresssComponent,
        CheckoutExpandableComponent,
        TranslationModule,
        CheckoutPaymentMethodsComponent,
        AddressShortComponent,
        Section1Component,
        BasketViewCouponFormComponent,
        AbModule,
    ]
})
export class CheckoutPaymentComponent {
    /**
     * expandable id
     */
    get expandableId(): string[] {
        return this.checkout.getExpandableId('payment');
    }
    get expandableOff(): boolean {
        return this.checkout.isExpandableOff('payment');
    }
    /**
     * Address data
     */
    get address(): Checkout.IBillingAddress {
        return this.checkout.data.address.billing;
    }

    get addressShorterVersion(): string {
        const address = this.checkout.data.address;
        if (this.checkout.data.shipping.method === 'storepickup_storepickup') {
            return `
            ${address.billing.firstname || ''} ${address.billing.lastname || ''}<br>
            ${address.billing.street_1 || ''}<br>
            ${address.billing.street_2 ? address.billing.street_2 + '<br>' : ''}
            ${address.billing.city || ''} ${address.billing.region || ''}<br>
            ${address.billing.postcode || ''}`;
        } else if (this.checkout.data.billing.to_shipping) {
            return `
            ${address.shipping.firstname || ''} ${address.shipping.lastname || ''}<br>
            ${address.shipping.street_1}<br>
            ${address.shipping.street_2 ? address.shipping.street_2 + '<br>' : ''}
            ${address.shipping.city} ${address.shipping.region || ''}<br>
            ${address.shipping.postcode}
            `;
        } else
            return `
            ${address.billing.firstname || address.shipping.firstname || ''} ${address.billing.lastname  || address.shipping.lastname || ''}<br>
            ${address.billing.street_1 || address.shipping.street_1}<br>
            ${(address.billing.street_2 ? address.billing.street_2 + '<br>' : '')  || address.shipping.street_2 ? address.shipping.street_2 + '<br>' : ''}
            ${address.billing.city || address.shipping.city} ${address.billing.region || address.shipping.region  || ''}<br>
            ${address.billing.postcode || address.shipping.postcode}`;
    }
    constructor(public checkout: CheckoutFormComponent) {}
}
